/**
 * TanStack Query hooks for `igaming-tiered-commission-by-ngr-ftd-wager-thresholds`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys,
	type CreateIgamingTieredCommissionByNgrFtdWagerThresholdsBody,
	type ListIgamingTieredCommissionByNgrFtdWagerThresholdsResponse,
	type IgamingTieredCommissionByNgrFtdWagerThresholdsRow,
} from "./api";

export function useIgamingTieredCommissionByNgrFtdWagerThresholdsList(): UseQueryResult<ListIgamingTieredCommissionByNgrFtdWagerThresholdsResponse, Error> {
	return useQuery({
		queryKey: igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingTieredCommissionByNgrFtdWagerThresholdsCreate(): UseMutationResult<IgamingTieredCommissionByNgrFtdWagerThresholdsRow, Error, CreateIgamingTieredCommissionByNgrFtdWagerThresholdsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys.all });
		},
	});
}

export function useIgamingTieredCommissionByNgrFtdWagerThresholdsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingTieredCommissionByNgrFtdWagerThresholdsQueryKeys.all });
		},
	});
}
